import Crud from '../views/Abas/Crud'
import Entity from '../views/Abas/Add'

let routes = {
    path: '/tabs',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tabs/add',
            name: 'NewAbas',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Abas',
                breadcrumb: [
                    {
                        text: 'Aba',
                        active: false,
                        to: '/tabs',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/tabs/edit/:id?',
            name: 'EditAbas',
            component: Entity,
            meta: {
                pageTitle: 'Editar Abas',
                breadcrumb: [
                    {
                        text: 'Aba',
                        active: false,
                        to: '/tabs',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/tabs',
            name: 'list-tabs',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Abas',
                breadcrumb: [
                    {
                        text: 'Abas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
